import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const SupplierInfoWindow = (props) => {
    const { supplierInfo, location, context } = props;
    const styles = useStyles();

    return (
        <React.Fragment>
            <Grid item xs={12} className={styles.supplierInfowWindow}>
                <Card className={styles.root}>
                    <CardContent className={styles.cardContent}>
                        <Typography className={styles.title} gutterBottom>
                            {supplierInfo.supplier_name}
                        </Typography>
                        <Typography className={styles.pos}>
                            {supplierInfo.address}
                        </Typography>
                        {/* <Typography variant="body2" component="p" className={styles.content}>
                            {supplierInfo.risk} {supplierInfo.risk > 1 ? "risks" : "risk"} affecting this supplier
                        </Typography> */}
                    </CardContent>
                    {/* <CardActions>
                        <Button variant="contained" size="small" className={styles.btn}>
                            Show Associated Risks
                        </Button>
                    </CardActions> */}
                </Card>
            </Grid>
        </React.Fragment>
    );
}
const useStyles = makeStyles(() => ({
    root: {
        borderRadius: '0px',
        width: 250,
        boxShadow: 'none'
    },
    supplierInfowWindow: {
        '& Button': {
            backgroundColor: '#363740',
            color: '#FFFFFF',
            fontSize: 12,
            fontFamily: "Inter",
            fontStyle: 'normal',
            fontWeight: '500',
        },
        '& .MuiButton-root:hover': {
            backgroundColor: '#363740',
        },
        '& .MuiCardActions-root': {
            padding: '0px 8px 8px 0px'
        },
        '& .MuiButton-root': {
            textTransform: 'none'
        }

    },
    title: {
        fontSize: 16,
        fontFamily: "Inter",
        fontStyle: 'normal',
        fontWeight: '700',
        letterSpacing: '0.2px'
    },
    pos: {
        fontSize: 14,
        fontFamily: "Inter",
        fontStyle: 'normal',
        fontWeight: '500',
        letterSpacing: '0.2px',
        color: '#000000'
    },
    content: {
        fontSize: 12,
        fontFamily: "Inter",
        letterSpacing: '0.2px',
        marginTop: 12,
        fontWeight: '300',
        color: '#000000'
    },
    cardContent: {
        padding: '0px 0px 16px 0px'

    },
}));


export default SupplierInfoWindow;